import React, { useState, useEffect, useContext } from "react";
import "../../styles/transaction.css";
import "../../styles/contact/faq.css";

const faqData = [
  {
    question: "How can I purchase data from you?",
    answer: `STEP 1: Fund your wallet.
STEP 2: Fill the data order form.
STEP 3: Wait for 5-15 minutes, the recipient will receive notification(s) of data recharge`,
  },
 
  {
    question: "How can I fund my wallet?",
    answer: `You can fund your wallet using either of these payment means:

1. Bank payment
2. Online Payment with your ATM card details via Paystack Payment Gateway

`,
  },
  {
    question: "Can I share the data I buy from you with another line?",
    answer: `You can only share glo data plans, mtn, 9MOBILE and airtel data cant be shared.`,
  },
  {
    question: "How can I be your agent?",
    answer: `Our Products can be retailed, as they are affordable. You can retail our Products to others and make profit.
Just make sure your wallet is funded, then you can easily purchase for anyone you wish.`,
  },
  {
    question: "Can I send airtime to you for data bundle?",
    answer: `Yes you can, but payment with airtime attracts little additional charge. Kindly fund your wallet with airtime.`,
  },
  {
    question: "Are your data plans legit?",
    answer: `Yea, we are third party data vendors. We buy in bulk from network providers and resell.`,
  },
  {
    question: "Hope the data won't get exhausted quickly or disappear?",
    answer: `Our data plans are sourced from the network providers, therefore consumption rate is similar to the data gotten directly from them.`,
  },
  {
    question: "What are the other products/services you offer?",
    answer: `We sell Cheap Internet Data Plans, Airtime VTU on MTN, 9MOBILE, GLO and AIRTEL, we Convert Airtime To Cash, Airtime Swap, Bills Payment (GOTV, DSTV, STARTIMES).`,
  },
  {
    question: "What if my order was cancelled but my wallet was not refunded?",
    answer: `You can contact our customer care agent through the live chat or via whatsapp, by clicking on the whatsapp button on the Contact page`,
  },
];

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <p className="faq-subtext">
        Click on each question to see answers, click again to hide it.
      </p>

      {faqData.map((faq, index) => (
        <div
          key={index}
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
          onClick={() => toggleFAQ(index)}
        >
          <div className="faq-question">{faq.question}</div>
          {activeIndex === index && (
            <div className="faq-answer">
              {faq.answer.split("\n").map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Faq;
